import { DroppedScreenService } from './dropped-screen-service';
import { RootScopeEvents } from 'common/services/root-scope-types';
export class DroppedScreenServicePatient extends DroppedScreenService {
    constructor($injector) {
        super($injector);
        this.$injector = $injector;
        const title = this.$translate.instant('video-chat.dropped.network.title');
        const messages = {
            networkDisconnected: {
                icon: '#call-dropped',
                title,
                btnText: this.$translate.instant('video-chat.patient.dropped-call'),
                description: this.$translate.instant('video-chat.patient.dropped.network.description'),
                onBtnClick: () => {
                    this.message = null;
                },
            },
            networkDisconnectedGroupCall: {
                icon: '#call-dropped',
                title,
                btnText: this.$translate.instant('video-chat.patient.dropped-call'),
                description: this.$translate.instant('video-chat.patient.dropped-group-call.network.description'),
                onBtnClick: () => {
                    this.message = null;
                },
            },
            doctorNetworkDisconnected: {
                icon: '#call-dropped',
                title,
                btnText: this.$translate.instant('video-chat.patient.dropped-call'),
                description: this.$translate.instant('video-chat.patient.dropped.doctor-network.description'),
                onBtnClick: () => {
                    this.message = null;
                },
            },
        };
        const handleNetworkDisconnected = (participants) => {
            if (participants.length < 2) {
                this.message = messages.networkDisconnected;
            }
            else {
                this.message = messages.networkDisconnectedGroupCall;
            }
            this.$rootScope.$evalAsync();
        };
        // close popup if doctor initiated a new call
        this.$rootScope.$on('globalUi:startCall', () => {
            this.message = null;
            this.$rootScope.$evalAsync();
        });
        // sessson dropped because of provider`s network
        this.$rootScope.$on('patient:stop:doctorNetworkDisconnected', () => {
            this.message = messages.doctorNetworkDisconnected;
            this.$rootScope.$evalAsync();
        });
        // sessson dropped because network
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, (e, { reason, participants }) => {
            if (reason === 'networkDisconnected') {
                handleNetworkDisconnected(participants);
            }
        });
        // we stop the call on video provider exception
        this.$rootScope.$on('activeProvider:stopBecauseOfNetworkError', (e, { participants }) => {
            handleNetworkDisconnected(participants);
        });
    }
}
